var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.87,
    height: 18.67,
    viewBox: "0 0 15.87 18.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-copy-icon {\n        fill: currentColor;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "content_copy_FILL0_wght400_GRAD0_opsz48",
    className: "cls-copy-icon",
    d: "M121.4,193.67a1.436,1.436,0,0,1-1.4-1.4V178.2h1.4V192.27h11.062v1.4Zm2.8-2.8a1.436,1.436,0,0,1-1.4-1.4V176.4a1.436,1.436,0,0,1,1.4-1.4h10.268a1.436,1.436,0,0,1,1.4,1.4v13.069a1.436,1.436,0,0,1-1.4,1.4Zm0-1.4h10.268V176.4H124.2Zm0,0v0Z",
    transform: "translate(-120 -175)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.87d58da5c9268f57ea91ff8aba0be7e9.svg";
export { ForwardRef as ReactComponent };